import React from 'react'
import { Button } from '@chakra-ui/react'
import { Formik, Form, Field, FormikProps } from 'formik'
import * as Yup from 'yup'
import { Column, FormDialog } from 'src/ui'
import { TextField as FormikTextField } from 'src/ui/formik'
import { convertEmptyStringsToNull } from 'src/companies/configurations/utils'

const CompanySchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  slug: Yup.string()
    .strict(true)
    .required('Required')
    .lowercase('Must be lowercase')
    .matches(/^[a-zA-Z0-9]+$/, 'May only contain alphanumeric characters'),
  parent_slug: Yup.string()
    .strict(true)
    .lowercase('Must be lowercase')
    .matches(/^[a-zA-Z0-9]+$/, 'May only contain alphanumeric characters'),
})

type CreateCompanyDialogProps = DialogProps & {
  company?: any
}

export function CreateCompanyDialog({
  isOpen,
  onClose,
  onConfirm,
  company,
}: CreateCompanyDialogProps) {
  return (
    <FormDialog title="Create Company" isOpen={isOpen} onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={{
          name: company?.name ?? '',
          slug: company?.slug ?? '',
        }}
        validationSchema={CompanySchema}
        onSubmit={(values) => onConfirm(convertEmptyStringsToNull(values))}
      >
        {(formikBag: FormikProps<any>) => (
          <>
            <FormDialog.Body>
              <Form>
                <Column>
                  <Field name="name" label="Name" component={FormikTextField} />
                  <Field name="slug" label="Slug" component={FormikTextField} />
                  <Field name="parent_slug" label="Parent Slug" component={FormikTextField} />
                </Column>
              </Form>
            </FormDialog.Body>

            <FormDialog.Footer>
              <Button
                size="sm"
                variant="ghost"
                mr={2}
                onClick={() => {
                  formikBag.resetForm()
                  onClose()
                }}
              >
                Cancel
              </Button>

              <Button
                size="sm"
                colorScheme="primary"
                type="submit"
                isLoading={formikBag.isSubmitting}
                onClick={() => formikBag.submitForm()}
              >
                Create
              </Button>
            </FormDialog.Footer>
          </>
        )}
      </Formik>
    </FormDialog>
  )
}
